import { ALL_LOCATIONS, PAGE_PARAM } from '@/app/lib/constants'
import { routes } from '@/app/lib/routing'

import { READABLE_FILTER_PARAMS } from '@/app/entradas/(general-web)/[slug]/[slug2]/[slug3]/_components/parseSubcategoriaFilters'

/**
 * Orden fijo de los 2 selectores de `fields` que quedan tras sacar Precio a
 * `rangeField` (revisado — mismo mecanismo que Promociones/Lo más vendido,
 * unifica la maquetación del selector de precio): Ordenar por → Provincia. El
 * `onApply` genérico de `ListingFilters` entrega los valores del borrador por
 * posición, así que este orden traduce cada posición a su destino real.
 */
export const FIELD_ORDER = ['sort', 'province'] as const

function withoutPage(currentSearch: string): URLSearchParams {
  const next = new URLSearchParams(currentSearch)
  next.delete(PAGE_PARAM)
  return next
}

function compose(base: string, params: URLSearchParams): string {
  const qs = params.toString()
  return qs ? `${base}?${qs}` : base
}

function setOrDelete(params: URLSearchParams, key: string, value: string | undefined) {
  if (value) params.set(key, value)
  else params.delete(key)
}

/**
 * URL al cambiar de provincia (FR-018): navega el segmento `[location]`
 * preservando los query params actuales menos `page`. Provincia vacía → `todos`.
 */
export function buildProvinceHref(
  categoria: string,
  subcategoria: string,
  provinceValue: string,
  currentSearch: string,
): string {
  const next = withoutPage(currentSearch)
  const target = provinceValue || ALL_LOCATIONS
  return compose(routes.subcategoria(categoria, target, subcategoria), next)
}

/**
 * URL al aplicar el borrador del SideSheet: Ordenar como query param,
 * Provincia como segmento de ruta; resetea `page`. `applied` viene en el orden
 * de `FIELD_ORDER`. Precio ya no entra (aplicación instantánea, fuera del
 * borrador — ver `rangeField` en `SubcategoriaFilters.tsx`).
 */
export function buildApplyHref(
  categoria: string,
  subcategoria: string,
  applied: readonly string[],
  currentSearch: string,
): string {
  const next = withoutPage(currentSearch)
  setOrDelete(next, READABLE_FILTER_PARAMS.sort, applied[FIELD_ORDER.indexOf('sort')])
  const provinceValue = applied[FIELD_ORDER.indexOf('province')] || ALL_LOCATIONS
  return compose(routes.subcategoria(categoria, provinceValue, subcategoria), next)
}
